import { render, staticRenderFns } from "./OrderListTable.vue?vue&type=template&id=38b5ef35"
import script from "./OrderListTable.vue?vue&type=script&lang=js"
export * from "./OrderListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports